import { Formik, FormikFormProps, FormikProps } from 'formik'
import React from 'react'
import { AnySchema, InferType, ObjectSchema } from 'yup'

import { Box } from 'widgets/Box'

import { FormErrors } from './FormErrors'
import { SubmitButton } from './SubmitButtonNew'

interface FormProps<Values extends Record<string, unknown> = Record<string, unknown>>
  extends FormikFormProps {
  errors?: string[] | string
  onSubmit: (values: Values) => void
  loading?: boolean
  children?: (props: FormikProps<Values>) => JSX.Element
  submitCopy?: string
  initialValues?: Values
  validationSchema?: InferType<ObjectSchema<Record<string, AnySchema>>>
}

// This Form is a wrapper around the Formik component.
export const Form = <Values extends Record<string, unknown>>({
  errors = [],
  children,
  submitCopy,
  loading,
  initialValues = {} as Values,
  ...props
}: FormProps<Values>) => {
  return (
    <Box margin={{ horizontal: 'md' }}>
      <Formik<Values>
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={initialValues}
        {...props}
      >
        {({ handleSubmit, ...formikProps }: FormikProps<Values>) => (
          <Box>
            {children &&
              children({
                handleSubmit,
                ...formikProps,
              })}

            <FormErrors errors={errors} />

            {submitCopy ? (
              <Box margin={{ top: 'md' }}>
                <SubmitButton title={submitCopy} handleSubmit={handleSubmit} loading={loading} />
              </Box>
            ) : null}
          </Box>
        )}
      </Formik>
    </Box>
  )
}
